import {
  ROUTE_STATE_CHANGES
} from './actions';
import {query, homeRoute} from '../../constants/public-routes';

export let lastQuery = function (state = null, action) {
  switch (action.type) {
    case ROUTE_STATE_CHANGES: {
      const currLang = action.state.params.lang;
      const currRoute = action.state.location.pathname;
      let resetRoutes = [query(currLang), homeRoute(currLang)];
      if (currRoute === query(action.state.params.lang) && action.state.location.search !== '') {
        return query(action.state.params.lang, action.state.location.search);
      }
      if (resetRoutes.indexOf(currRoute) >= 0) {
        return null;
      }
    }
  }
  return state;
};



/** WEBPACK FOOTER **
 ** ./src/modules/routing/reducers.js
 **/